import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';

import { HelmetProvider } from 'react-helmet-async';

import Home from './home/Home';
import Issues from '../../views/issues/Issues';
import Issue from '../../views/issue/Issue';
import Drafts from '../../views/drafts/Drafts';
import Preview from '../../views/preview/Preview';
import Feature from '../../views/feature/Feature';

import '../../App.variables.css';
import './App.css';

import config from '../../config';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	const routes = [
		{
			path: '/',
			element: <Home />,
		},
		{
			path: '/issues',
			element: <Issues />,
		},
		{
			path: '/issues/:id',
			element: <Issue />,
		},
		{
			path: '/issues/:id/:articleId',
			element: <Issue />,
		},
		{
			path: '/feature/:issueId/:articleId',
			element: <Feature />,
		},
		{
			path: '/preview/:id',
			element: <Preview />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}
	routes.push({
		path: '*',
		element: <Navigate to="/" replace />,
	});
	const router = createBrowserRouter(routes, {
		basename,
	});

	return (
		<HelmetProvider>
			<div className="app-magazine">
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
